import {useMemo} from 'react';
import {getStoredUser} from '../../utils/auth';
import {createInventoryApi} from './inventoryApi.mjs';

// A retired page must never borrow the next operator's token for late work.
// The server remains responsible for authentication and action permissions.
export default function useInventoryAccountApi(email){
 const actor=String(email||'').trim().toLowerCase();
 return useMemo(()=>createInventoryApi({getAccessToken:()=>{
  const user=getStoredUser();
  return actor&&String(user?.email||'').trim().toLowerCase()===actor?user.accessToken:null;
 }}),[actor]);
}
